import type {FC} from 'react'
import ExternalBookmarkTable from './Components/ExternalBookmarkTable'
import BasicDashboardContainer from '@shared/components/BasicDashboardContainer'

const ExternalBookmarkComponent: FC = () => (
  <BasicDashboardContainer data-testid="basic-dashboard-container-anomaly-table">
    <ExternalBookmarkTable />
  </BasicDashboardContainer>
)

export default ExternalBookmarkComponent
